import TagRuleBase from './TagRuleBase';
import { observable } from 'mobx';
import { ElasticSearchScriptQueryRuleResult, RuleError } from '../types';
import PipelineStep from '../../pipeline_base/models/PipelineStep';
import PipelineStepType from '../types/PipelineStepType';
import { RuleStatus } from './RuleBase';

export default class ElasticSearchScriptQueryRule extends TagRuleBase<
    ElasticSearchScriptQueryRule,
    ElasticSearchScriptQueryRuleResult
> {
    @observable
    script: string;

    @observable
    excludedBlockTypes: string[];

    @observable
    includedBlockTypes: string[] | null;

    constructor(
        id: string | null,
        projectId: string | null,
        name: string,
        tagId: string | null,
        tag: string,
        script: string,
        pipeline: PipelineStep<PipelineStepType>[] = [],
        groupId: string | null,
        updateDate?: Date,
        priority: number = 1,
        description?: string,
        state?: 'Enabled' | 'Disabled',
        status: RuleStatus = RuleStatus.Valid,
        overridePriority: boolean = false,
        excludedBlockTypes: string[] = [],
        errors?: RuleError[],
        includedBlockTypes?: string[] | null
    ) {
        super(
            id,
            projectId,
            name,
            tagId,
            tag,
            'ElasticSearchScriptQueryRule',
            pipeline,
            groupId,
            updateDate,
            priority,
            description,
            state,
            status,
            overridePriority,
            errors
        );
        this.script = script;
        this.excludedBlockTypes = excludedBlockTypes || [];
        this.includedBlockTypes = includedBlockTypes?.slice() ?? null;
    }

    clone(): ElasticSearchScriptQueryRule {
        return new ElasticSearchScriptQueryRule(
            this.id,
            this.projectId,
            this.name,
            this.tagId,
            this.tag,
            this.script,
            this.clonePipeline(),
            this.groupId,
            this.updateDate,
            this.priority,
            this.description,
            this.state,
            this.status,
            this.overridePriority,
            this.excludedBlockTypes.slice(),
            this.errors,
            this.includedBlockTypes
        );
    }

    validateState(): string[] {
        if (!this.name || !this.script || !this.tag) {
            return ['Fill all fields'];
        }

        const errors = this.validatePipeline();

        return errors;
    }

    toJson(): ElasticSearchScriptQueryRuleResult {
        const json: ElasticSearchScriptQueryRuleResult = {
            ruleType: this.ruleType,
            id: this.id,
            groupId: this.groupId,
            name: this.name,
            script: this.script,
            tagId: this.tagId,
            tag: this.tag,
            pipeline: this.pipelineToJSON(),
            projectId: this.projectId,
            priority: this.priority,
            description: this.description,
            state: this.state,
            status: this.status,
            overridePriority: this.overridePriority,
            excludedBlockTypes: this.excludedBlockTypes,
            includedBlockTypes: this.includedBlockTypes
        };

        return json;
    }
}
